import React from 'react'
import AddOnsTile from './AddOnsTile'
import { Button } from '@corratech/pylot-ui'
import { AdonsStepProps } from '../../lib/type'
import { useTranslation } from 'next-i18next'
import { BundleItemOption } from '@pylot-data/fwrdschema'
import { Subtotal } from '@corratech/pylot-custom-kit-flow/src/Components/Subtotal'
import s from './AddOnsStep.module.scss'
import cn from 'classnames'

export const AddOnsStep = ({
    product,
    setStep,
    step,
    selectedOptions,
    setSelectedOptions,
    addOns,
    setAddOns,
    addProductHandler,
    isAddToCartInProgress,
    isFavourite
}: AdonsStepProps): JSX.Element => {
    const adons = product?.items?.filter(
        (item) => item?.ooka_product_option === 'pods'
    )
    const { t } = useTranslation(['common', 'plp'])
    const selectedOptionsAdons: BundleItemOption[] = []
    adons?.forEach((flavour) => {
        flavour?.options?.forEach((option) => {
            if (selectedOptions?.includes(String(option?.uid))) {
                selectedOptionsAdons.push(option!)
            }
        })
    })

    const inStockProducts =
        product?.upsell_products?.filter(
            (item) => item?.stock_status !== 'OUT_OF_STOCK'
        ) || []
    const outOfStockProducts =
        product?.upsell_products?.filter(
            (item) => item?.stock_status === 'OUT_OF_STOCK'
        ) || []

    const sortedProducts = [...inStockProducts, ...outOfStockProducts]

    return (
        <div>
            <div className={s['addon-container']}>
                <p className={s['upgrade-your']}>
                    {t('Upgrade your Experience')}
                </p>
                <div className={cn(s['flavour-list'])}>
                    {sortedProducts.map((individualProduct, index) => {
                        return (
                            <div
                                key={individualProduct?.sku}
                                className={
                                    product?.upsell_products?.length === 1
                                        ? 'col-start-2'
                                        : ''
                                }
                            >
                                <AddOnsTile
                                    index={index}
                                    product={individualProduct}
                                    className="item"
                                    selectedOptions={selectedOptions}
                                    setSelectedOptions={setSelectedOptions}
                                    addOns={addOns}
                                    disableAddingAdons={
                                        individualProduct?.stock_status ===
                                        'OUT_OF_STOCK'
                                    }
                                    qty={addOns?.[individualProduct?.sku!]?.qty}
                                    setAddOns={setAddOns}
                                />
                            </div>
                        )
                    })}
                </div>
            </div>
            <div className={s['price-container']}>
                {!isFavourite ? (
                    <div className={s['price']}>
                        <Subtotal
                            product={product}
                            selectedOptions={selectedOptions}
                            addOns={addOns}
                        />
                    </div>
                ) : (
                    ''
                )}
                <div className="flex m-auto p-0 pb-4 md:p-4 w-full md:w-auto">
                    <Button
                        type="button"
                        className={s['add-to-cart-button']}
                        loading={isAddToCartInProgress}
                        onClick={() => {
                            if (
                                setStep &&
                                typeof step === 'number' &&
                                addProductHandler
                            ) {
                                addProductHandler(Object.keys(adons!))
                            }
                        }}
                    >
                        {t(
                            isAddToCartInProgress
                                ? 'Adding product'
                                : 'Go to Checkout'
                        )}
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default AddOnsStep
